import * as Services from '@services';
import { RoleEditModel } from '@models';
import { makeAutoObservable } from 'mobx';

class RoleStore {
  roles!: Services.PagedResultDto<Services.GetAllRoleOutput>;

  roleEdit: RoleEditModel = new RoleEditModel();

  allPermissions: Services.GetAllPermissionsOutput[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  async create(createRoleInput: Services.CreateRoleInput) {
    await Services.RoleService.create(createRoleInput);
  }

  async createRole() {
    this.roleEdit = {
      grantedPermissionNames: [],
      role: {
        name: '',
        displayName: '',
        description: '',
        id: 0,
      },
      permissions: [{ name: '', displayName: '', description: '' }],
    };
  }

  async getRolesAsync(getRoleAsyncInput: Services.GetRoleAsyncInput) {
    await Services.RoleService.getRolesAsync(getRoleAsyncInput);
  }

  async update(updateRoleInput: Services.UpdateRoleInput) {
    await Services.RoleService.update(updateRoleInput);
    this.roles.items
      .filter((x: Services.GetAllRoleOutput) => x.id === updateRoleInput.id)
      .map((role: Services.GetAllRoleOutput) => {
        role = updateRoleInput;
        return role;
      });
  }

  async delete(entityDto: Services.EntityDto) {
    await Services.RoleService.delete(entityDto);
    this.roles.items = this.roles.items.filter(
      (x: Services.GetAllRoleOutput) => x.id !== entityDto.id
    );
  }

  async getAllPermissions() {
    const result = await Services.RoleService.getAllPermissions();
    this.allPermissions = result;
  }

  async getRoleForEdit(entityDto: Services.EntityDto) {
    const result = await Services.RoleService.getRoleForEdit(entityDto);
    this.roleEdit.grantedPermissionNames = result.grantedPermissionNames;
    this.roleEdit.permissions = result.permissions;
    this.roleEdit.role = result.role;
  }

  async get(entityDto: Services.EntityDto) {
    const result = await Services.RoleService.get(entityDto);
    this.roles = result.data.result;
  }

  async getAll(pagedFilterAndSortedRequest: Services.PagedRoleResultRequestDto) {
    const result = await Services.RoleService.getAll(pagedFilterAndSortedRequest);
    this.roles = result;
  }
}

export default RoleStore;
